import React, { Component } from 'react';
import { Col, Button, Input } from 'react-materialize';
import AuthService from '../services/AuthService';
import './Login.css';
import logo from './logo.png';


class Login extends Component {
  state = {
    email: '',
    password: '',
    token: null
  }

  constructor(){
    super();
    this.Auth = new AuthService();

  }

  login(){
    this.Auth.login(this.state.email, this.state.password)
  }

  render(){

    return (

      <div className='vCenter' > 
        <Col s={12} m={6} l={4} offset={'m3 l4'}>

          <img  className="logo" src={logo} alt="logo"></img>
          <Input type={"text"} label={"E-mail"} name={"email"} s={12} onChange={(e) => { this.setState({ email: e.target.value }) }}></Input>
          <Input type={"password"} label={"Senha"} name={"password"} s={12} onChange={(e) => { this.setState({ password: e.target.value }) }}></Input>

          <div>

            <Col s={12} m={10} l={12} offset={'s1'}>
              <Button className='gsaude' waves='light' onClick={ () => { this.login() } }>Gestão de Saúde</Button>
              <Button className='grecursos' waves='light'>Gestão de Recursos</Button>
            </Col>

          </div>

        </Col>
      </div>

    );

  }

}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js